<template>
    <v-layout column>
        <v-container grid-list-xs>
            <v-row>
                <v-col class="px-1"
                    cols="12"
                    md="4" >
                    <v-card class=" " height="100%">
                        <v-toolbar color="primary " dark  >
                            Mobile Reporters
                        </v-toolbar>
                        <v-row class="">
                            <v-col cols="8" class="">
                                <v-card class="mx-3" color="transparent" flat > 
                                    <v-card-subtitle class="text-no-wrap ps-2">
                                        Calculated on: {{ not.NUMBER_SHOW(ReportSummary.mobile_size) }} of {{ not.NUMBER_SHOW(ReportSummary.total_size) }} Total Reports
                                    </v-card-subtitle>
                                    <v-card-text class="">
                                        <v-layout lass="ma-0" justify-center>
                                            <div class="text-center font-weight-bold primary--text mb-2  not-f9">
                                                {{ not.NUMBER_SHOW(ReportSummary.mobile_percent) }}%
                                                 
                                            </div>
                                            
                                        </v-layout>
                                    </v-card-text> 
                                    <v-btn :to="'/reports/mobile'" color="accent"><v-icon color="primary" class="mr-2">mdi-eye</v-icon> View Reports</v-btn>
                                </v-card>
                            </v-col> 
                            <v-col cols="4">
                                <v-img
                                contain
                                height="180"
                                width="159"
                                :src="require(`@/assets/images/misc/triangle-${$vuetify.theme.dark ? 'dark':'light'}.png`)"
                                class="greeting-card-bg"
                                ></v-img>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
                <v-col class="" 
                    cols="12"
                    md="8" >
                    <v-card height="100%">
                        <v-toolbar color="primary " dark  >
                            Response Overview
                        </v-toolbar>
                        <v-card-title class="align-start"> 
                        <v-spacer></v-spacer>
                        <v-btn
                            icon
                            small
                            class="me-n3 mt-n2"  >
                            <v-icon>
                            </v-icon>
                        </v-btn>
                        </v-card-title>
            
                        <v-card-subtitle class="mb-8 mt-n5">
                        <span class="font-weight-regular text--primary me-1">An overview of stats around the nation</span>
                        <span></span>
                        </v-card-subtitle>
            
                        <v-card-text>
                        <v-row>
                            <v-col
                                cols="6"
                                md="4"
                                class="" >
                                <v-card flat @click="VIEW_REPORTERS()" >
                                    <v-layout row wrap> 
                                        <v-avatar
                                            size="44"
                                            rounded color="primary"
                                            class="elevation-1" >
                                            <v-icon
                                            dark
                                            color="accent"
                                            size="30" >mdi-account-plus
                                            </v-icon>
                                        </v-avatar>
                                        <div class="ms-3">
                                            <p class="text-xl mb-0">
                                                Reporters
                                            </p>
                                            <h3 class="text-xl font-weight-semibold">
                                                M: {{not.NUMBER_SHOW(ReportSummary.mobile_reporters_size)}}
                                                W: {{not.NUMBER_SHOW(ReportSummary.web_reporters_size)}}
                                            </h3>
                                        </div> 
                                    </v-layout>
                                </v-card>
                            </v-col>
            
                            <v-col
                            cols="6"
                            md="4"
                            class="d-flex align-center"
                            >
                            <v-avatar
                                size="44"
                                rounded color="primary"
                                class="elevation-1"
                            >
                                <v-icon
                                dark
                                color="accent"
                                size="30">mdi-vote
                                </v-icon>
                            </v-avatar>
                            <div class="ms-3">
                                <p class="text-xl mb-0">
                                All Reports
                                </p>
                                <h3 class="text-xl font-weight-semibold">
                                {{not.NUMBER_SHOW(ReportSummary.total_size)}}
                                </h3>
                            </div>
                            </v-col>
            
                            <v-col
                            cols="6"
                            md="4"
                            class="d-flex align-center"
                            >
                            <v-avatar
                                size="44"
                                rounded color="primary"
                                class="elevation-1"
                            >
                                <v-icon
                                dark
                                color="accent"
                                size="30">mdi-message
                                </v-icon>
                            </v-avatar>
                            <div class="ms-3">
                                <p class="text-xl mb-0">
                                    Citizen SMS 
                                </p>
                                <h3 class="text-xl font-weight-semibold">
                                {{not.NUMBER_SHOW(ReportSummary.sms_size)}} 
                                </h3>
                            </div>
                            </v-col>
                        </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
        
                <v-col
                    cols="12"
                    md="4"
                    >
                    <v-row class="match-height"> 
                        <v-col class="pa-1"
                            cols="12"
                            sm="12"
                            >
                            <v-card class="greeting-card " height="100%">
                                <v-toolbar color="primary " dark  >
                                    Web Reports
                                </v-toolbar>
                                <v-row class="">
                                    <v-col cols="8" class="">
                                        <v-card class="mx-3" color="transparent" flat > 
                                            <v-card-subtitle class="text-no-wrap ps-2">
                                                    Calculated on: {{ not.NUMBER_SHOW(ReportSummary.web_size) }} of {{ not.NUMBER_SHOW(ReportSummary.total_size) }} Total Reports
                                                </v-card-subtitle>
                                                <v-card-text class="">
                                                    <v-layout class="ma-0" justify-center>
                                                        <p class="text-center font-weight-bold primary--text mb-2  not-f9">
                                                            {{ not.NUMBER_SHOW(ReportSummary.web_percent) }}%
                                                        </p>
                                                    </v-layout>
                                                </v-card-text> 
                                                <v-btn :to="'/reports/web'" color="accent"><v-icon color="primary" class="mr-2">mdi-eye</v-icon>View Reports</v-btn>
                                            </v-card>
                                    </v-col>
                    
                                    <v-col cols="4">
                                    <v-img
                                        contain
                                        height="180"
                                        width="159"
                                        :src="require(`@/assets/images/misc/triangle-${$vuetify.theme.dark ? 'dark':'light'}.png`)"
                                        class="greeting-card-bg"
                                    ></v-img>
                                    </v-col> 
                                </v-row>
                            </v-card>
                        </v-col>
            
                        <v-col class="pa-1"
                            cols="12"
                            sm="12"
                            >
                            <v-card class="greeting-card mt-3" height="100%">
                                <v-toolbar color="primary " dark  >
                                    Whatsapp
                                </v-toolbar>
                                <v-row class="">
                                <v-col cols="8" class="">
                                    <v-card class="mx-3" color="transparent" flat > 
                                        <v-card-subtitle class="text-no-wrap ps-2">
                                            
                                            Calculated on: {{ not.NUMBER_SHOW(ReportSummary.whatsapp_size) }} of {{ not.NUMBER_SHOW(ReportSummary.total_size) }} Total Reports
                                        </v-card-subtitle>
                                        <v-card-text class="">
                                            <v-layout lass="ma-0" justify-center >
                                            <p class="text-center font-weight-bold primary--text mb-2  not-f9">
                                                {{ not.NUMBER_SHOW(ReportSummary.whatsapp_percent) }}%
                                            </p>
                                            </v-layout>
                                        </v-card-text> 
                                        <v-btn :to="'/reports/whatsapp'" color="accent"><v-icon color="primary" class="mr-2">mdi-eye</v-icon>View Reports </v-btn>
                                    </v-card>
                                </v-col>
                
                                <v-col cols="4">
                                    <v-img
                                    contain
                                    height="180"
                                    width="159"
                                    :src="require(`@/assets/images/misc/triangle-${$vuetify.theme.dark ? 'dark':'light'}.png`)"
                                    class="greeting-card-bg"
                                    ></v-img>
                                </v-col>
                                </v-row>
                            </v-card>
                        </v-col> 
                    </v-row>
                </v-col>
                <v-col cols="12" md="8" class="pt-">  
                    <v-card  class="pa- mt-1 " height="100%"  >
                        <v-toolbar color="primary " dark  >
                            Interventions
                            <v-spacer></v-spacer>
                            <v-menu  
                                v-model="menu_item_sorting"
                                :close-on-content-click="true" 
                                offset-y  offset-overflow
                                :nudge-width="70" rounded="xl"
                                >
                                <template v-slot:activator="{ on, attrs }">  
                                    <v-btn  v-on="on" 
                                        ref="btn_selling_mode"
                                        :disabled="false"  
                                        class="ml-1 mb-1 pl-0 pr-1" color="accent"> 
                                        <v-icon class="ml-2">sort_by_alpha</v-icon>
                                        <v-icon class="ml-">arrow_drop_down</v-icon>
                                    </v-btn> 
                                </template> 
    
                                <v-card  v-if="ud"  
                                    color="lighten-1" class="">  
                                    <v-card-title class="primary lighten-1 white--text py-" dark>
                                        Sort Interventions 
                                    </v-card-title> 
                                    <v-layout class="ma-0">
                                        <v-list dense> 
                                            <div v-for="(model,index) in itemSorting" :key="index">
                                                <v-list-item :class="model.code == item_sorting.code?'secondary--text':''" @click="item_sorting=model">{{model.name}}</v-list-item> 
                                            </div>
                                        </v-list>   
                                    </v-layout>
                                </v-card>  
                            </v-menu>  
                        </v-toolbar>
                        <!-- <v-simple-table :height="vs.height-60" fixed-header> -->
                        <v-simple-table  fixed-header height="100%">
                            <template v-slot:default>
                                <thead>
                                <tr class=" ">
                                    <th class="text-uppercase primary--text">
                                    </th>
                                    <th class="text-uppercase black--text" >
                                        Intervention Name
                                    </th>
                                    <th class="text-uppercase text-center black--text ">
                                        Questionnaires
                                    </th>
                                    <th class="text-uppercase text-center black--text ">
                                        Web
                                    </th> 
                                    <th class="text-uppercase text-center black--text ">
                                        Mobile
                                    </th> 
                                    <th class="text-uppercase text-center black--text ">
                                        Action
                                    </th>  
                                </tr>
                                </thead>
                                <tbody>
                                <tr
                                    v-for="(item,index) in SortedOccurrences"
                                    :key="index" >
                                    <td class="pr-0">
                                        <v-avatar
                                            size="30" tile
                                            :color="item.color_code" >
                                            <v-icon size="30" color="primary">event_note </v-icon>
                                        </v-avatar>
                                    </td>
                
                                    <td> 
                                    {{ item.name }} 
                                    </td>
                                    <td class="text-center">
                                        {{ not.NUMBER_SHOW(item.questionnaires_size) }}
                                    </td>
                                    <td class="text-center">
                                        {{ not.NUMBER_SHOW(item.web_reports_size) }}
                                    </td> 
                                    <td class="text-center">
                                        {{ not.NUMBER_SHOW(item.mobile_reports_size) }}
                                    </td> 
                                    <td class="text-center">
                                        <v-btn color="accent" :to="'/intervention/'+item.code" outlined><v-icon color="primary" class="mr-2">mdi-eye</v-icon>View </v-btn>
                                    </td> 
                                </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-card>
                </v-col>
            </v-row> 
            <br><br> 
        </v-container> 
    </v-layout>
</template>

<script>
    import DATA from '../../plugins/DATA'
    import {mapState} from "vuex"
    let PAGE_NAME = "DASHBOARD"    
    export default {
        name:PAGE_NAME, 
        props:['not'],  
        data() {
            return {
                PAGE_LOAD:false,  
                PAGE_CURRENT:1,
                PAGE_SIZE:10, 
                DATA:DATA,
                menu_item_sorting:false,
                item_sorting:{code:1}, 
                item_sorting_loading:false, 
                itemSorting:[
                    {code:1,name:"Sort by Name (A-Z)"},
                    {code:2,name:"Sort by Name (Z-A)"},
                    {code:3,name:"Sort by Quantity (Low-High)"},
                    {code:4,name:"Sort by Quantity (High-Low)"},
                    {code:5,name:"Counted (First-Last)"},
                    {code:6,name:"Counted (Last-Fist)"}
                ],
            }
        },
        created() {
            try {
                this.MBS.events.$on('DIALOG_YES', this.DIALOG_YES);  
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'created',
                    page:PAGE_NAME, 
                }) 
            }
        },
        mounted() {
            try {
                 
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'mounted',
                    page:PAGE_NAME, 
                }) 
            }
            
        },
        computed: { 
            ...mapState({
                loading:state=>state.load.loading,
                processes:state=>state.load.processes,
                responses:state=>state.load.responses,
            }),
            ...mapState({
                us: state=> state.users[(DATA.ITEMS.USERS.value).toUpperCase()],
                ud: state=> state.users[(DATA.ITEMS.USER_DETAILS.values).toUpperCase()],
            }),
            ...mapState({
                Occurrences: state=> state.items[(DATA.ITEMS.OCCURRENCES.values).toUpperCase()],
                JoinedOccurrences: state=> state.join[(DATA.ITEMS.OCCURRENCES.values).toUpperCase()],
                WebReports: state=> state.items[(DATA.ITEMS.WEB_REPORTS.values).toUpperCase()],
                JoinedWebReports: state=> state.join[(DATA.ITEMS.WEB_REPORTS.values).toUpperCase()],
                MobileReports: state=> state.items[(DATA.ITEMS.MOBILE_REPORTS.values).toUpperCase()],
                JoinedMobileReports: state=> state.join[(DATA.ITEMS.MOBILE_REPORTS.values).toUpperCase()],
                SMSReports: state=> state.items[(DATA.ITEMS.SMS_REPORTS.values).toUpperCase()],
                JoinedSMSReports: state=> state.join[(DATA.ITEMS.SMS_REPORTS.values).toUpperCase()],
                Reporters: state=> state.items[(DATA.ITEMS.REPORTERS.values).toUpperCase()],
                JoinedReporters: state=> state.join[(DATA.ITEMS.REPORTERS.values).toUpperCase()],
                ReporterCategories: state=> state.items[(DATA.ITEMS.REPORTER_CATEGORIES.values).toUpperCase()],
                JoinedReporterCategories: state=> state.join[(DATA.ITEMS.REPORTER_CATEGORIES.values).toUpperCase()]
            }),  
            ReporterCategoriesData(){
                return this.JoinedReporterCategories?this.JoinedReporterCategories:this.ReporterCategories
            },
            OccurrencesData(){
                
                console.log(this.JoinedOccurrences,'this.JoinedOccurrences.1...');
                return this.JoinedOccurrences?this.JoinedOccurrences:this.Occurrences
            },
            filteredOccurrences(){ 
                let occurrences = this.OccurrencesData
                if(!occurrences){return null}
                let items = occurrences.filter(item=>!item.disabled)
                return items
            },
            SortedOccurrences(){ 
                let occurrences = this.filteredOccurrences
                let item_sorting = this.item_sorting
                let sorting_code = item_sorting?item_sorting.code:null
                if(!occurrences){return null}
                //sort
                if (item_sorting) {
                    if(item_sorting.code==1){
                        occurrences.sort(this.MBS.actions.dynamicSort("name",true))   
                    }else if(item_sorting.code==2){
                        occurrences.sort(this.MBS.actions.dynamicSort("name",false))    
                    }else if(item_sorting.code==3){
                        occurrences.sort(this.MBS.actions.dynamicSort("questionnaires_size",true))    
                    }else if(item_sorting.code==4){
                        occurrences.sort(this.MBS.actions.dynamicSort("questionnaires_size",false))    
                    }else if(item_sorting.code==5){
                        occurrences.sort(this.MBS.actions.dynamicSort("no",true))   
                    }else if(item_sorting.code==6){
                        occurrences.sort(this.MBS.actions.dynamicSort("no",false))   
                    } 
                } 
                console.log(occurrences,'......');
                return occurrences
            },
            MobileReportsData(){ 
                return this.JoinedMobileReports?this.JoinedMobileReports:this.MobileReports
            },
            WebReportsData(){ 
                console.log(this.WebReports,'this.WebReports.****...');
                return this.JoinedWebReports?this.JoinedWebReports:this.WebReports
            },
            SMSReportsData(){ 
                return this.JoinedSMSReports?this.JoinedSMSReports:this.SMSReports
            },
            ReportersData(){
                return this.JoinedReporters?this.JoinedReporters:this.Reporters
            },
            ReportUsers(){
                let mobile = this.MobileReportsData
                let web = this.WebReportsData 
                let sms = this.SMSReportsData 
                let mobile_reporters = []
                let web_reporters = []
                let sms_reporters = []
                if (mobile) {
                    mobile.forEach(report => {
                        let reporter = report.reporter
                        if (reporter) {
                            let indexOf = mobile_reporters.findIndex(item=>item.key == reporter.key)
                            if (indexOf == -1) {
                                mobile_reporters.push({...reporter,reports_number:1})
                            }else{
                                mobile_reporters[indexOf].reports_number++
                            }
                        }
                    }); 
                }
                if (web) {
                    web.forEach(report => {
                        let reporter = report.reporter
                        if (reporter) {
                            let indexOf = web_reporters.findIndex(item=>item.key == reporter.key)
                            if (indexOf == -1) {
                                web_reporters.push({...reporter,reports_number:1})
                            }else{
                                web_reporters[indexOf].reports_number++
                            } 
                        }
                    }); 
                }
                if (sms) {
                    sms.forEach(report => { 
                        let indexOf = sms_reporters.findIndex(item=>item.phone == report.from)
                        if (indexOf == -1) {
                            sms_reporters.push({
                                phone:report.from,
                                reports_number:1
                            })
                        }else{
                            sms_reporters[indexOf].reports_number++
                        }  
                    }); 
                }
                let all={
                    mobile_reporters : mobile_reporters,
                    web_reporters : web_reporters,
                    sms_reporters : sms_reporters,
                    
                    mobile_reporters_size : this.MBS.actions.SIZE(mobile_reporters),
                    web_reporters_size : this.MBS.actions.SIZE(web_reporters),
                    sms_reporters_size : this.MBS.actions.SIZE(sms_reporters),
                } 
                return all
            },
            ReportSummary(){
                let mobile = this.MobileReportsData
                let web = this.WebReportsData 
                let sms = this.SMSReportsData 
                let reporters = this.ReportersData 
                let ReportUsers = this.ReportUsers 

                let mobile_size = this.MBS.actions.SIZE(mobile)
                let web_size = this.MBS.actions.SIZE(web)
                let sms_size = this.MBS.actions.SIZE(sms)
                let reporters_size = this.MBS.actions.SIZE(reporters)
                let total_size = mobile_size+web_size+sms_size
                let mobile_percent = mobile_size*100/total_size
                let web_percent = web_size*100/total_size
                let summary = {
                    web_size:web_size,
                    mobile_size:mobile_size,
                    sms_size:sms_size,
                    reporters_size:reporters_size,
                    total_size:total_size,
                    mobile_percent:mobile_percent.toFixed(2),
                    web_percent:web_percent.toFixed(2),
                    whatsapp_percent:0,
                     
                }
                if (ReportUsers) {
                    summary = {
                        ...summary,
                        ...ReportUsers
                    }
                }
                console.log(summary,'summary.......');
                return summary
            },

            route(){
                return this.$route
            },
            vs(){
                return this.$vuetify.breakpoint
            },  
            MY_LINKS(){  
                let thisLinks = this.MBS.actions.FIND_SUB_LINKS("catalog",1,true) 
                return thisLinks
            }, 
            PATH_ITEM(){  
                let path = DATA.PATHS.countries
                return path
            }, 
            HEADER_ITEMS(){
                return [ 
                    {id:1,name:"General",title:true}, 
                    {id:0,name:"Number",value:'no',show:false},   
                    {id:0,name:"code",align:"center",show:true},     
                    {id:0,name:"Name",value:"name",show:true},       
                    {id:0,name:"Description",value:"description",show:true},       
                    {id:0,name:"create",value:'created_at_',show:true},    
                    {id:0,name:"update",value:'updated_at_',show:false},   
                    {id:0,name:"action",align:"right",show:true,item:[ 
                        {name:"Edit "+this.NAME_ITEM,action:"edit_item",icon:"edit"}, 
                        {name:"Delete "+this.NAME_ITEM,action:"delete_item",icon:"mdi-delete"},
                    ]}, 
                ]
            },
            HEADER_ITEMS2(){
                return [ 
                    {id:1,name:"General",title:true}, 
                    {id:0,name:"Number",value:'no',show:true},  
                    {id:0,name:"name",show:true}, 
                    {id:0,name:"code",align:"center",show:true},      
                    {id:0,name:"action",align:"right",show:true,item:[  
                        {name:"Edit "+this.NAME_ITEM,action:"edit_item",icon:"mdi-pencil"},
                        {name:"Delete "+this.NAME_ITEM,action:"delete_item",icon:"mdi-delete"},
                    ]}, 
                ]
            },  
        },
        methods: { 


            TABLE_ACTION(action,item){
                try {
                    let route = this.route
                    let fullPath = route?route.fullPath:null
                     console.log(action,'action');
                    if (action == "order_stock") {
                        this.MBS.actions.go(fullPath+"/order")
                    }else if (action == "received_stock") {
                        this.MBS.actions.go(fullPath+"/receive")
                    }else if (action == "return_stock") {
                        this.MBS.actions.go(fullPath+"/return")
                    }else if (action == "transfer_stock") {
                        this.MBS.actions.go(fullPath+"/transfer")
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'TABLE_ACTION',
                        page:PAGE_NAME, 
                    }) 
                }
                
            }, 
            VIEW_REPORTERS(){
                try {
                    let summary = this.ReportSummary
                    let mobile_reporters = summary?summary.mobile_reporters:null
                    let web_reporters = summary?summary.web_reporters:null
                    let sms_reporters = summary?summary.sms_reporters:null
                    let reporters_size = summary?summary.reporters_size:0
                    let mobile_reporters_size = summary?summary.mobile_reporters_size:0
                    let web_reporters_size = summary?summary.web_reporters_size:0
                    let sms_reporters_size = summary?summary.sms_reporters_size:0

                    let mobile_names = ''
                    let web_names = ''
                    let sms_names = ''
                    if (mobile_reporters) {
                        mobile_reporters.forEach(report => {
                            mobile_names = mobile_names+"\n"+report.first_name+' '+report.last_name+' | R='+report.reports_number 
                        })
                    }if (web_reporters) {
                        web_reporters.forEach(report => {
                            web_names = web_names+"\n"+report.first_name+' '+report.last_name+' | R='+report.reports_number 
                        })
                    }if (sms_reporters) {
                        sms_reporters.forEach(report => {
                            sms_names = sms_names+"\n"+report.phone+' | R='+report.reports_number 
                        })
                    }
                    this.MBS.actions.dialog({
                        show:true,
                        title:"REPORTERS",
                        text:"The following is Reporters Summary: \n\nALL REPORTERS = "+reporters_size+ 
                            "\n\nMOBILE REPORTERS:"+mobile_reporters_size+mobile_names+
                            "\n\nWEB REPORTERS:"+web_reporters_size+web_names+
                            "\n\nSMS REPORTERS:"+sms_reporters_size+sms_names,
                        btnYes:"Okay"
                    })
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'VIEW_REPORTERS',
                        page:PAGE_NAME, 
                    }) 
                }
                
            }, 
            //---------------[MAIN FUNCTIONS]------------ 
            DIALOG_YES(action){ 
                try {
                    if (action.code) {
                        if (action.code ===PAGE_NAME+'=ADD-ITEM') {
                            if (action.YES) {
                                if (this.input.check) { 
                                    this.input.check = false 
                                    setTimeout(() => {
                                        this.input.loading = true 
                                        this.$store.dispatch("fi_add",{
                                            action:this.VALUE_ITEM,
                                            path:this.PATH_ITEM,
                                            data:action.data,
                                            us:this.us
                                        })
                                    }, ACTION_TIME);  
                                }   
                            } else {
                                
                            }
                        }  
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'DIALOG_YES',
                        page:PAGE_NAME, 
                    }) 
                }  
            },  
            FEEDBACKS(time){  
                try {
                    if (!time) { time=400 }
                    setTimeout(()=>{
                        let us = this.loggedUser 
                        let ps = this.processes
                        let ld = this.loading
                        let res = this.responses

                        //Check process 
                        if (ps) {
                            let gettingItems = ps.find(process=>{
                                return process.name == 'getting/'+this.VALUE_ITEMS
                            }) 
                             
                        }else{
                            this.PAGE_LOAD =true
                        } 
                    },time)
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'FEEDBACKS',
                        page:PAGE_NAME, 
                    })  
                } 
            },
              
        },
        watch: {  
            loading:{ 
                handler:"FEEDBACKS",
                immediate:true
            } ,
            processes:{ 
                handler:"FEEDBACKS",
                immediate:true
            },
            responses:{ 
                handler:"FEEDBACKS",
                immediate:true
            } 
        },
    }
</script>
 
